const apiConfig = {
    baseUrl: `https://api.themoviedb.org/3/`,
    apiKey: '088f4df643022cbbe2a297babd84490c',
    originalImage: imgPath => `https://image.tmdb.org/t/p/original/${imgPath}`,
    w500Image: imgPath => `https://image.tmdb.org/t/p/w500/${imgPath}`,
}

export default apiConfig;